import type {
  AuthorizedTradingUrlResponse,
  TradingAuthorizeVariables,
} from '@/shared/types';
import { handleRequest } from '../apiWrapper';
import { apiClient } from '..';

export const getAuthorizedTradingUrl = async ({
  clientId,
  state,
  redirectUrl,
  isReplace,
}: TradingAuthorizeVariables): Promise<AuthorizedTradingUrlResponse> => {
  const request = () =>
    apiClient.get(`/security/trading/authorize`, {
      params: {
        clientId: clientId,
        state: state,
        redirectUrl: redirectUrl,
      },
    });
  const response = await handleRequest<AuthorizedTradingUrlResponse>(request);

  if (response.status === 200 && !isReplace) {
    window.open(response.data.tradingUrl, '_blank');
  }

  return response.data;
};
